import { createListenerMiddleware } from '@reduxjs/toolkit';

import type { User } from '../user/types';
import { fetchUser } from '../user/thunks';

import { setupUserPilot } from '@/scripts/userPilot';

// Create the listener middleware instance
export const thirdPartyScriptsListener = createListenerMiddleware();

// React strict mode will call this twice, so we need to prevent it
// TODO: Once we lock down initialization process and loading state, we should be able to remove this
let scriptsLoaded = false;

thirdPartyScriptsListener.startListening({
  actionCreator: fetchUser.fulfilled,
  effect: (action) => {
    if (scriptsLoaded) return;
    scriptsLoaded = true;
    const user = action.payload as User;
    setupUserPilot(user);
  },
});
